import { Events } from './events';

/**
 * Register PDF download event handler
 * Downloads the static reference PDF file
 */
const registerPdfDownload = (events: Events) => {
    events.function('download.reference.pdf', () => {
        // Create a temporary link element for download
        const link = document.createElement('a');
        link.href = '/static/files/biligoba-reference.pdf';
        link.download = 'Biligoba-Reference.pdf';
        link.target = '_blank'; // Open in new tab as fallback

        // Trigger download
        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
    });
};

export { registerPdfDownload };
